import { LogOut } from "lucide-react";
import type { Project, User } from "../../api/types.js";
import { demoAssets } from "../shared/constants.js";

export function UserProfileCard({
  user,
  activeProject,
  onLogout
}: {
  user: User;
  activeProject: Project | undefined;
  onLogout: () => void;
}) {
  return (
    <div className="sidebar-bottom">
      <div className="profile-card">
        <img src={demoAssets.avatar} alt="" />
        <div>
          <strong>{user.displayName || activeProject?.name || "acelsss"}</strong>
          <span>存储空间 12.5MB / 10GB</span>
          <div className="storage-bar"><i /></div>
        </div>
        <button className="mini-icon" type="button" title="退出" onClick={onLogout}><LogOut size={15} /></button>
      </div>
    </div>
  );
}
